<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>调拨信息单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="transVoucherInfo" :rules="voucherInfo" ref="ruleForm">
            <div class="content-caption dashed">
                <span>调拨信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">调出部门</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="srcComFullName" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="transVoucherInfo.srcComFullName"></el-input>
                            <i v-if="!taxRateChange && id == null" class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectSrcBizUnitName"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">预定说明</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="applyDesc" :rules="{validator: checkEmpty, trigger: 'blur'}">
                            <el-input placeholder="例如:XX设备调拨,请领导审批" :disabled="taxRateChange" type="textarea" v-model="transVoucherInfo.applyDesc" resize="both"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>

        <div class="content-caption dashed">
            <span>资产信息</span>
            <div class="input-tip error fr font12">提示:一次调拨数据最多2000条</div>
        </div>
        <div class="simple-row" v-if="!taxRateChange">
            <div class="left">
                <el-button type="primary" @click="showDeviceListDlg()">
                    <span>闲置资产选择</span>
                </el-button>
            </div>
        </div>
        <div class="table-layout">
            <div class="right-toolbar mb5 fr">
                <span>已选择({{ (transVoucherInfo.itemList || []).length }})</span>
            </div>
            <el-form :model="transVoucherInfo" ref="deviceItem">
                <el-table ref="multipleTable" :data="transVoucherInfo.itemList.slice(startIndex, endIndex)" border maxHeight="500" tooltip-effect="dark">
                    <el-table-column align="left" prop="innerCode" label="资产编号" fixed="left" width="150">
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row)">{{ rows.row.innerCode }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="assetType" width="100" label="管理方式" align="center" fixed="left">
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="innerNo" label="外部资产编码" width="180" align="left"></el-table-column>
                    <el-table-column align="left" prop="title" width="200" label="资产描述全称"></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" width="180" label="规格"></el-table-column>
                    <el-table-column align="center" prop="reserved" width="80" label="预定情况">
                        <template slot-scope="rows">
                            <span>{{ rows.row.reserved ? '已被预定' : '可以预定' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="transQuantity" label="调拨数量" width="80" align="right"></el-table-column>
                    <el-table-column label="控制方式" align="center" width="80">
                        <template slot-scope="scope">
                            <span>{{ scope.row.splitible ? '按金额' : '按数量' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="整批调拨" align="center" width="80">
                        <template slot-scope="scope">
                            <input type="checkbox" :disabled="id != null || scope.row.assetType == commonDevcVal" v-model="scope.row.transAll" @change="splitFlagChange(scope.$index)"/>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="quantity" label="本次调拨数量" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.assetType == commonDevcVal">{{ scope.row.quantity }}</span>
                            <el-form-item :prop="'itemList.' + scope.$index + '.quantity'" :rules="{validator: inputTransAvQuantity, trigger: 'blur'}" v-else>
                                <el-input :disabled="disabledQuantity(scope.row.splitible, scope.row.splitFlag)" type="number" min="1" class="input-content-right" @change="transAvQuantityChange(scope);"
                                          v-model.number="scope.row.quantity"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="theUnit" label="单位" width="60"></el-table-column>
                    <el-table-column align="right" prop="splittedAmount" width="100" label="调拨原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.assetType == commonDevcVal">{{ rows.row.orgWorth }}</span>
                            <el-form-item :prop="'itemList.' + rows.$index + '.splittedAmount'" :rules="{validator: inputSplittedAmount, trigger: 'blur'}" v-else>
                                <input style="width:90%" :disabled="!rows.row.splitible || !rows.row.splitFlag" type="number" min="0" class="input-content-right" @change="splittedAmountChange(rows);"
                                       v-model.number="rows.row.splittedAmount"/>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth" width="80" label="资产原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.assetOrgWorth != null">{{ rows.row.assetOrgWorth.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="调入机构" width="300">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null">{{ scope.row.dstMerchantName }}</span>
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null && scope.row.dstComFullName != null">/</span>
                            <span>{{ scope.row.dstComFullName || '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dstComNo" label="调入机构编号" width="120"></el-table-column>
                    <el-table-column prop="dstCostCenterCode" label="调入成本中心" width="160"></el-table-column>
                    <el-table-column prop="srcComFullName" label="调出部门全称" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="srcRealComCode" label="调出公司编码" width="160"></el-table-column>
                    <el-table-column prop="srcCostCenterCode" label="调出成本中心" width="160"></el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" align="right" width="100" v-if="srcNormalFlag">
                        <template slot-scope="scope">
                            <span v-if="!taxRateChange">{{ scope.row.taxRate }}</span>
                            <el-select v-else-if="taxRateChange" v-model="scope.row.taxRate" placeholder="请选择税率">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deprMonth" label="入账时间" width="150" align="right">
                        <template slot-scope="rows">
                            <span v-if="rows.row.fiscalInTime != null">{{ rows.row.fiscalInTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="memo" label="备注" width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input :disabled="taxRateChange" v-model="scope.row.memo" type="textarea"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="tmpNo" width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="quantity2" label="含报废数量" width="120"></el-table-column>
                    <el-table-column prop="devcCustTag1Val" :label="devcCustTag1.dispName" width="120" v-if="devcCustTag1.enabled == true" >
                    </el-table-column>
                    <el-table-column prop="devcCustTag2Val" :label="devcCustTag2.dispName" width="120" v-if="devcCustTag2.enabled == true">
                    </el-table-column>
                    <el-table-column prop="devcCustTag3Val" :label="devcCustTag3.dispName" width="120" v-if="devcCustTag3.enabled == true">
                    </el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <a v-if="!taxRateChange" class="swb-btn-link" @click="removeDeviceItem(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-layout" style="overflow: hidden">
                    <el-pagination class="fr" background v-if="totalCount > 10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                                   layout="prev, pager, next, jumper, sizes, total"></el-pagination>
                </div>
            </el-form>
        </div>

        <div class="content-caption dashed">
            <span>标题</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">标题</label>
                </div>
                <div class="form-value width-2x">
                    <el-input placeholder="例如:调拨电子秤一台。" :disabled="taxRateChange" type="textarea" v-model="transVoucherInfo.memo" resize="both"></el-input>
                </div>
            </div>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" v-if="!autoApplyAndAudit && id != null" @click="saveTransVoucher(true)">申请</button>
            <button class="swb-btn swb-btn-small" @click="saveTransVoucher(false)">保存</button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox, Routes, Vue} from '../../app.vues'
    import {syncSetBreadcrumb} from '../index';
    import {showDevcSelectDlg} from '../devc/selectDlg'
    import {getMerchantBizParam} from '../asset/assetMain'
    import {openBizUnitOrgTreeDlg} from '../orgStruct/selectDlg'
    import {getMerchtAuditBpConfInfo, openAuditTypeDlg, openDingdingAuditViewDlg, openOaAuditBpNodeDlg} from '../oaAudit/selectDlg'
    import {assetFiscalInfoDlg} from '../retailer/dialog';
    import {getDefaultPageSizes} from '../../../src/app.conf'
    import {showComActionPostSelectDlg} from '../merchant/showSelectDlg';

    import userApi from '../../api/user'
    import assetVchrApi from '../../api/assetVchr'
    import fiscalBizApi from '../../api/fiscalBiz'
    import oaAuditApi from '../../api/oaAudit';
    import retailerApi from '../../api/retailer';
    import shopStockApi from '../../api/shopStock';
    import shopDeviceApi from '../../api/shopDevc';
    //
    import SwbShopDeviceTransVoucherAuditList from './ShopDeviceTransVoucherAuditList';
    import custTagMeataApi from '../../api/objTagConf';

    Routes.add(SwbShopDeviceTransVoucherAuditList);

    export default {
        name: 'swb-shop-device-trans-voucher-reserve-save',
        path: '/trans/voucher/reserve/save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: true,
        desc: '预定调拨单-维护',
        data: function () {
            let validateWarehouseId = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请选择'));
                } else {
                    callback();
                }
            };
            return {
                taxRateChange: false,
                isAuditBpConfAvailable: false,
                needAssignAuditors: false,
                dingDingAuditFlag: false,
                commonDevcVal: getEnumInfoWith('assetType', 'name', 'CommonDevc').value,
                assetTypeMap: getEnumMap("assetType", "value2text"),
                transVoucherInfo: {
                    suitFlag: false,
                    srcBizUnitId: null,
                    srcBizUnitName: null,
                    dstBizUnitId: null,
                    dstBizUnitName: null,
                    outerNo: null,
                    memo: null,
                    itemList: [],
                    //
                    dstMerchantId: null,
                    dstMerchantName: null,
                    dstComId: null,
                    dstComName: null,
                    dstWarehouseId: null,
                    dstWarehouseName: null
                },
                srcTransVoucherInfo: null,
                srcItemList: [],
                //
                id: null,
                suitIds: [],    // 回显套装使用
                // 选择禁用
                transItemList: [],
                reloadItemInfo: false,
                //
                voucherInfo: {
                    srcWarehouseId: [{validator: validateWarehouseId, trigger: 'blur'}],
                    dstWarehouseId: [{validator: validateWarehouseId, trigger: 'blur'}]
                },
                allotAcntMethodMap: getEnumMap("allotAcntMethod", "value2text"),
                allotAcntTypeMap: getEnumMap("allotAcntType", "value2text"),
                durableDevcVal: getEnumInfoWith("assetType", "name", "DurableDevc").value,
                parentPath: null,
                //
                srcNormalFlag: false,
                scopeEntity: null,
                dstComInfo: {},
                //
                fiscalTaxMarkList: [],
                defaultTaxRate: 0,
                suiteMgmtEnabled: false, // 是否开启资产/设备套装管理
                bizUnitId: null,
                bizUnitName: null,
                dstNormalFlag: null,
                dstWareHouseList: [],
                //
                pageSize: getDefaultPageSizes().first(),
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                totalCount: 0,
                startIndex: 0,
                endIndex: 0,
                devcCustTag1: {
                    dispName: '自定义标签1',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag2: {
                    dispName: '自定义标签2',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag3: {
                    dispName: '自定义标签3',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                }
            }
        },
        created: function () {
            let self = this;
            self.getCustTagMetaFields();
            getMerchantBizParam("asset.trans.biz.default.tax.rate", function (result) {
                self.defaultTaxRate = result;
            });
            getMerchantBizParam("device.or.asset.suite.mgmt.enabled", function (result) {
                self.suiteMgmtEnabled = Utils.isTrue(result);
            });
            getMerchtAuditBpConfInfo("retailer.assets.allot", false, function (auditBpConfInfo) {
                self.needAssignAuditors = Utils.isTrue(auditBpConfInfo.needAssignAuditors);
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2 && auditBpConfInfo.ready);
            });
            //
            this.id = this.$route.query.id || null;
            this.bizUnitId = this.$route.query.bizUnitId || null;
            this.bizUnitName = this.$route.query.bizUnitName || null;
            let taxRateChange = this.$route.query.taxRateChange;
            if (taxRateChange != null) {
                this.taxRateChange = taxRateChange;
            }
            this.parentPath = this.$route.query.parentPath || null;
            this.isAuditBpConfAvailable = this.$route.query.isAuditBpConfAvailable || null;
            //
            let fistTitle = "资产调拨";
            let title = Utils.isNoB(this.id) ? "新增" : "修改";
            syncSetBreadcrumb(fistTitle + "-" + title, this.parentPath);
            //
            this.getCurrentUserInfo();
            if (!Utils.isNoB(this.id)) {
                this.getShopDeviceTransVoucher();
            }
            this.getFiscalTaxMarkList();
        },
        methods: {
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', "name", "XXS").value;
                //
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        } else {
                            fiscalTaxMarkList.push({
                                rate: 0
                            });
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopDeviceTransVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                assetVchrApi.getShopDeviceTransVoucherById(postData, function (result) {
                    if (result.type == "info") {
                        let dbVoucher = result.data;
                        self.transVoucherInfo = Utils.merge({}, dbVoucher);
                        // 保留初始数据，用于返回 校验
                        self.srcTransVoucherInfo = Utils.merge({}, dbVoucher);
                        self.srcItemList = Utils.merge([], dbVoucher.itemList);
                        self.setPageList();
                        getMerchantBizParam("asset.finac.enabled", function (result) {
                            self.srcNormalFlag = Utils.isTrue(result);
                        }, 2, dbVoucher.srcComId);
                        getMerchantBizParam("asset.finac.enabled", function (resultX) {
                            self.dstNormalFlag = Utils.isTrue(resultX);
                        }, 2, dbVoucher.dstComId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            checkNull: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请选择!'));
                } else {
                    callback();
                }
            },
            checkEmpty: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity || {};
                        self.scopeEntity = scopeEntity;
                        //
                        if (Utils.isNoB(self.id)) {
                            //
                            let transVoucherInfo = self.transVoucherInfo || {};
                            transVoucherInfo.dstBizUnitId = scopeEntity.bizUnitId;
                            transVoucherInfo.dstBizUnitName = scopeEntity.bizUnitName;
                            transVoucherInfo.dstComId = scopeEntity.bizUnitId;
                            transVoucherInfo.dstComName = scopeEntity.bizUnitName;
                            transVoucherInfo.dstComFullName = scopeEntity.bizUnitName;
                            self.transVoucherInfo = Utils.merge({}, transVoucherInfo);
                            //
                            getMerchantBizParam("asset.finac.enabled", function (resultX) {
                                self.dstNormalFlag = Utils.isTrue(resultX);
                            }, 2, scopeEntity.bizUnitId);
                            self.getDstWarehouseList(scopeEntity.bizUnitId, function (dstWareHouseList) {
                                //
                                self.dstWareHouseList = Utils.merge([], dstWareHouseList);
                            });
                            // 获取调入机构
                            self.getComDetail(scopeEntity.comId);
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getDstWarehouseList: function (retailerShopId, callbackFun) {
                let filterItems = {};
                filterItems.retailerShopId = retailerShopId;
                let postData = {
                    filterItems: filterItems
                };
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        //
                        callbackFun(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComDetail: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                retailerApi.getRetailerCom(postData, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        self.dstComInfo = Utils.merge({}, data);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 选择调出机构
            selectSrcBizUnitName: function () {
                let self = this;
                let dlgConfig = {
                    enableSearch: true,
                    isRadio: true,
                    isCom: true,
                    bizDepart: true,
                    title: '零售商机构-选择'
                };
                openBizUnitOrgTreeDlg(dlgConfig, function (result, theDlg) {
                    theDlg.close();
                    if (result.id == self.scopeEntity.bizUnitId) {
                        MsgBox.warning("不可选择当前业务单元！");
                        return;
                    }
                    //
                    getMerchantBizParam("asset.finac.enabled", function (resultX) {
                        let srcNormalFlag = Utils.isTrue(resultX);
                        if (!self.dstNormalFlag && srcNormalFlag) {
                            MsgBox.warning('不允许从开启财务的业务单元向未开启财务的业务单元发起调拨资产');
                        } else {
                            //
                            let transVoucherInfo = self.transVoucherInfo || {};
                            transVoucherInfo.srcComId = result.id;
                            transVoucherInfo.srcComName = result.name;
                            transVoucherInfo.srcComFullName = result.fullName;
                            transVoucherInfo.srcBizUnitId = result.bizUnitId;
                            transVoucherInfo.srcBizUnitName = result.bizUnitName;
                            self.transVoucherInfo = Utils.merge({}, transVoucherInfo);

                            self.transItemList = [];
                        }
                    }, 2, result.bizUnitId);
                });
            },
            // 资产选择
            showDeviceListDlg: function () {
                let self = this;
                let srcComId = self.transVoucherInfo.srcComId;
                if (Utils.isNoB(srcComId)) {
                    MsgBox.warning("请选择调出部门！");
                    return;
                }
                //
                let filter = {};
                filter.retailerComId = srcComId;
                filter.assetIdleX = true;
                filter.locked = false;
                filter.cleared = false;
                filter.fiscalLocked = false;
                filter.scrapped = 0;
                filter.onlyDepart = !Utils.isNoB(self.id);   // 修改：只查询仅当前部门机构的数据
                // if (this.srcNormalFlag) {
                //     filter.userForTrans = true; // 在账的或无需入账的
                // }
                filter.fiscalAcctFlag = true;   // 仅调拨在账的资产
                let params = {
                    title: "闲置资产选择",
                    filter: filter,
                    devcBizClolumType: getEnumInfoWith("devcBizClolumType", "name", "ReserveDiaoBoDlg").name,   // 预定调拨选择
                    initSelectIds: self.transItemList.pluck('deviceXId') || [],
                    selectAll: true
                };
                showDevcSelectDlg(params, function (deviceList) {
                    //
                    let itemList = self.makeTransItems(deviceList);
                    self.transItemList = Utils.merge([], self.transItemList.concat(itemList));
                    self.transVoucherInfo.itemList = Utils.merge([], self.transItemList);
                    //
                    self.setPageList();
                });
            },
            // 资产处理
            makeTransItems: function (deviceItemList) {
                let self = this;
                let transItemInfo = self.transItemList[0] || null;
                //
                let itemsList = [];
                if (!Utils.isNoB(deviceItemList)) {
                    let scopeEntity = self.scopeEntity;
                    let srcTransVoucherInfo = self.srcTransVoucherInfo || {};
                    let dstComInfo = self.dstComInfo || {};
                    if (Utils.isNoB(dstComInfo)) {
                        dstComInfo = {
                            realComId: srcTransVoucherInfo.dstRealComId,
                            dstComInfo: srcTransVoucherInfo.dstRealComName,
                            costCenterCode: srcTransVoucherInfo.dstCostCenterCode
                        };
                    }
                    deviceItemList.forEach(function (deviceItem) {
                        //
                        let transQuantity = 0;
                        if (Utils.isTrue(deviceItem.assetType == self.durableDevcVal)) {
                            transQuantity = deviceItem.existQuanity - deviceItem.scrappedQuantity;
                            if (transQuantity < 0) {
                                transQuantity = 0;
                            }
                        } else {
                            transQuantity = 1;
                        }
                        let item = {
                            deviceXId: deviceItem.id,
                            devcDefId: deviceItem.devcDefId,
                            durable: Utils.isTrue(deviceItem.assetType == self.durableDevcVal),
                            assetType: deviceItem.assetType,
                            tmpNo: deviceItem.tmpNo,
                            catId: deviceItem.catId,
                            catName: deviceItem.catName,
                            brandId: deviceItem.brandId,
                            brandName: deviceItem.brandName,
                            title: deviceItem.title,
                            name: deviceItem.name,
                            model: deviceItem.model,
                            fixedSpec: deviceItem.fixedSpec,
                            modelSpec: deviceItem.modelSpec,
                            innerDevcCatId: deviceItem.innerDevcCatId,
                            innerDevcCatName: deviceItem.innerDevcCatName,
                            existQuanity: deviceItem.existQuanity, // 现存数量
                            inStkQuantity: deviceItem.inStkQuantity,
                            inStkAvQuantity: deviceItem.inStkAvQuantity,
                            scrappedQuantity: deviceItem.scrappedQuantity,
                            fiscalQuantity: deviceItem.fiscalQuantity,
                            inUse: Utils.isTrue(deviceItem.assetType == self.durableDevcVal) ? false : deviceItem.inUseQuantity > 0,
                            quantity: 1,
                            quantity2: 0,
                            transQuantity: transQuantity,
                            theUnit: deviceItem.theUnit,
                            batchNo: deviceItem.batchNo,
                            innerCode: deviceItem.innerCode,
                            innerNo: deviceItem.innerNo,
                            acctEnterWay: deviceItem.acctEnterWay,
                            fiscalAcctFlag: Utils.isTrue(deviceItem.fiscalAcctFlag == 1),
                            fiscalInTime: deviceItem.fiscalInTime,
                            orgWorth: deviceItem.orgWorth,
                            assetOrgWorth: deviceItem.orgWorth,
                            netWorth: deviceItem.netWorth,
                            aggtDeprWorth: deviceItem.aggtDeprWorth,
                            assetKindId: deviceItem.assetKindId,
                            assetKindName: deviceItem.assetKindName,
                            suitName: deviceItem.suitName,
                            suitId: deviceItem.suitId,
                            srcRealComName: deviceItem.retailerRealComName,
                            srcRealComCode: deviceItem.retailerRealComCode,
                            srcCostCenterCode: deviceItem.costCenterCode,
                            srcComId: deviceItem.retailerComId,
                            srcComName: deviceItem.retailerComName,
                            srcComFullName: deviceItem.retailerComFullName,
                            srcWarehouseId: deviceItem.warehouseId,
                            srcWarehouseName: deviceItem.warehouseName,
                            dstMerchantId: Utils.isNoB(self.id) ? scopeEntity.id : srcTransVoucherInfo.dstRetailerId,
                            dstMerchantName: Utils.isNoB(self.id) ? scopeEntity.name : srcTransVoucherInfo.dstRetailerName,
                            dstBizUnitId: Utils.isNoB(self.id) ? scopeEntity.bizUnitId : srcTransVoucherInfo.dstBizUnitId,
                            dstBizUnitName: Utils.isNoB(self.id) ? scopeEntity.bizUnitName : srcTransVoucherInfo.dstBizUnitName,
                            dstComId: Utils.isNoB(self.id) ? scopeEntity.bizUnitId : srcTransVoucherInfo.dstComId,
                            dstComName: Utils.isNoB(self.id) ? scopeEntity.bizUnitName : srcTransVoucherInfo.dstComName,
                            dstComFullName: Utils.isNoB(self.id) ? scopeEntity.bizUnitName : srcTransVoucherInfo.dstComFullName,
                            dstRealComId: dstComInfo.realComId,
                            dstRealComName: dstComInfo.realComName,
                            dstRealComCode: dstComInfo.realComCode,
                            dstCostCenterCode: dstComInfo.costCenterCode,
                            splitible: deviceItem.splitible,
                            splitFlag: true,
                            transAll: false,
                            splittedAmount: null,
                            //
                            retailerId: deviceItem.retailerId,
                            allotAcntMethod: deviceItem.allotAcntMethod,
                            taxRate: self.defaultTaxRate,
                            reserved: deviceItem.reserved,
                            devcCustTag1: deviceItem.devcCustTag1,
                            devcCustTag2: deviceItem.devcCustTag2,
                            devcCustTag3: deviceItem.devcCustTag3,
                            devcCustTag1Val: self.getDevcCustTagVal(1, deviceItem.devcCustTag1),
                            devcCustTag2Val: self.getDevcCustTagVal(2, deviceItem.devcCustTag2),
                            devcCustTag3Val: self.getDevcCustTagVal(3, deviceItem.devcCustTag3)
                        };
                        // 现存数量
                        let existQuanity = item.existQuanity || 0;
                        if (!Utils.isTrue(deviceItem.splitible)) {

                            //
                            let assetOrgWorth = item.assetOrgWorth || 0;
                            let fiscalQuantity = item.fiscalQuantity || 0;
                            //
                            if (Utils.isTrue(item.fiscalAcctFlag)) {
                                if (fiscalQuantity == 0) {
                                    fiscalQuantity = 1;
                                }
                                if (item.quantity >= fiscalQuantity) {
                                    item.splittedAmount = assetOrgWorth.toFixed(2);
                                } else {
                                    item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(fiscalQuantity)) * item.quantity).toFixed(2);
                                }
                            } else {
                                if (existQuanity == 0) {
                                    existQuanity = 1;
                                }
                                if (item.quantity >= existQuanity) {
                                    item.splittedAmount = assetOrgWorth.toFixed(2);
                                } else {
                                    item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(existQuanity)) * item.quantity).toFixed(2);
                                }
                            }
                        }
                        //
                        if (Utils.isTrue(item.fiscalAcctFlag)) {
                            // 报废数量
                            let scrappedQuantity = item.scrappedQuantity || 0;
                            // 现存未报废数量
                            let unScrappedQuantity = existQuanity - scrappedQuantity;
                            if (item.quantity > unScrappedQuantity) {
                                // 含报废数量
                                item.quantity2 = item.quantity - unScrappedQuantity;
                            } else {
                                // 含报废数量
                                item.quantity2 = 0;
                            }
                        }
                        //
                        let dstWareHouseList = self.dstWareHouseList || [];
                        if (!Utils.isNoB(self.id) && !Utils.isNoB(transItemInfo)) {
                            // 修改时 - 新增资产的调入机构从其他项获取，不可单独设置（因为修改的不能拆分调拨单，所以调入机构必须相同）
                            item.dstMerchantId = transItemInfo.dstMerchantId;
                            item.dstMerchantName = transItemInfo.dstMerchantName;
                            item.dstBizUnitId = transItemInfo.dstBizUnitId;
                            item.dstBizUnitName = transItemInfo.dstBizUnitName;
                            item.dstComId = transItemInfo.dstComId;
                            item.dstComNo = transItemInfo.dstComNo;
                            item.dstComName = transItemInfo.dstComName;
                            item.dstComFullName = transItemInfo.dstComFullName;
                            item.dstRealComName = transItemInfo.dstRealComName;
                            item.dstRealComCode = transItemInfo.dstRealComCode;
                            item.dstCostCenterCode = transItemInfo.dstCostCenterCode;
                            item.dstWareHouseList = Utils.merge([], dstWareHouseList);
                            item.dstWarehouseId = transItemInfo.dstWarehouseId;
                            item.dstWarehouseName = transItemInfo.dstWarehouseName;
                            item.allotAcntType = transItemInfo.allotAcntType;
                        } else {
                            self.getAllotAcntType(item, function (allotAcntType) {
                                item.allotAcntType = allotAcntType;
                                //
                                item.dstWareHouseList = Utils.merge([], dstWareHouseList);
                                let defWare = dstWareHouseList.find(function (ware) {
                                    return ware.defaulted == true;
                                });
                                item.dstWarehouseId = defWare.id;
                                item.dstWarehouseName = defWare.name;
                            });
                        }
                        //
                        itemsList.add(item);
                    });
                }
                return itemsList;
            },
            // 移除资产
            removeDeviceItem: function (index) {
                let theIndex = this.startIndex + index;
                let self = this;
                let itemList = self.transVoucherInfo.itemList || [];
                itemList.splice(theIndex, 1);
                self.transVoucherInfo.itemList = Utils.merge([], itemList);
                //
                this.transItemList = Utils.merge([], itemList);
                //
                this.setPageList();
            },
            getAllotAcntType: function (item, callBack) {
                let postData = {
                    dstComId: item.dstComId,
                    srcComId: item.srcComId
                };
                assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                    if (result.type === "info") {
                        //
                        callBack(result.data)
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 跳转资产详情
            viewAssetInfo: function (row) {
                let assetType = getEnumInfoWith('assetType', "name", "CommonDevc").value;
                let params = {
                    innerCode: row.innerCode,
                    assetType: assetType
                };
                assetFiscalInfoDlg(params);
            },
            // 是否需要拆分
            splitFlagChange: function (index) {
                let items = this.transVoucherInfo.itemList || [];
                let item = items[this.startIndex + index];
                if (Utils.isTrue(item.transAll)) {
                    item.splitFlag = false;
                    item.quantity = item.transQuantity;
                    //
                    let assetOrgWorth = item.assetOrgWorth || 0;
                    let fiscalQuantity = item.fiscalQuantity || 0;
                    // 现存数量
                    let existQuanity = item.existQuanity || 0;
                    if (Utils.isTrue(item.fiscalAcctFlag)) {
                        if (fiscalQuantity == 0) {
                            fiscalQuantity = 1;
                        }
                        if (item.quantity >= fiscalQuantity) {
                            item.splittedAmount = assetOrgWorth.toFixed(2);
                        } else {
                            item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(fiscalQuantity)) * item.quantity).toFixed(2);
                        }
                    } else {
                        if (existQuanity == 0) {
                            existQuanity = 1;
                        }
                        if (item.quantity >= existQuanity) {
                            item.splittedAmount = assetOrgWorth.toFixed(2);
                        } else {
                            item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(existQuanity)) * item.quantity).toFixed(2);
                        }
                    }

                } else {
                    item.splitFlag = true;
                }
                this.transVoucherInfo.itemList = Utils.merge([], items);
                this.transItemList = Utils.merge([], items);
            },
            // 调拨数量校验
            inputTransAvQuantity: function (rule, value, callback) {
                if (Utils.isNoB(value) || value < 1) {
                    callback(new Error('数量不可小于1'));
                } else {
                    if (!Utils.isIntStr(value)) {
                        callback(new Error('数量不可为小数'));
                    } else {
                        callback();
                    }
                }
            },
            // 数量变化校验
            transAvQuantityChange: function (scope) {
                let items = this.transVoucherInfo.itemList || [];
                items.forEach(function (item) {
                    if (item.deviceXId == scope.row.deviceXId) {
                        // 调拨数量
                        let quantity = item.quantity;
                        if (Utils.isNoB(quantity)) {
                            item.quantity = 1;
                            item.quantity2 = 0;
                        } else {
                            // 现存数量
                            let existQuanity = item.existQuanity || 0;
                            // 可调拨数量
                            let transQuantity = item.transQuantity || 0;
                            // 报废数量
                            let scrappedQuantity = item.scrappedQuantity || 0;
                            if (transQuantity < quantity && !item.splitible) {
                                Toast.show("当前调拨数量" + quantity + "，大于可调拨数量：" + transQuantity, 2000, 'info');
                            } else {
                                // 现存未报废数量
                                let unScrappedQuantity = existQuanity - scrappedQuantity;
                                if (quantity > unScrappedQuantity) {
                                    // 含报废数量
                                    let quantity2 = quantity - unScrappedQuantity;
                                    if (quantity2 > scrappedQuantity) {
                                        quantity2 = scrappedQuantity;
                                    }
                                    item.quantity2 = quantity2;
                                } else {
                                    // 含报废数量
                                    item.quantity2 = 0;
                                }
                                // 数量变动计算调拨金额
                                let assetOrgWorth = item.assetOrgWorth || 0;
                                let fiscalQuantity = item.fiscalQuantity || 0;
                                if (Utils.isTrue(item.fiscalAcctFlag)) {
                                    if (fiscalQuantity == 0) {
                                        fiscalQuantity = 1;
                                    }
                                    if (quantity >= fiscalQuantity) {
                                        item.splittedAmount = assetOrgWorth.toFixed(2);
                                    } else {
                                        item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(fiscalQuantity)) * quantity).toFixed(2);
                                    }
                                } else {
                                    if (existQuanity == 0) {
                                        existQuanity = 1;
                                    }
                                    if (quantity >= existQuanity) {
                                        item.splittedAmount = assetOrgWorth.toFixed(2);
                                    } else {
                                        item.splittedAmount = ((parseFloat(assetOrgWorth) / parseInt(existQuanity)) * quantity).toFixed(2);
                                    }
                                }
                            }
                        }
                    }
                });
                this.transVoucherInfo.itemList = Utils.merge([], items);
                this.transItemList = Utils.merge([], items);
            },
            disabledQuantity: function (splitible, splitFlag) {
                if (splitible) {
                    return splitible;
                } else {
                    return this.taxRateChange || !splitFlag
                }
            },
            // 调拨金额校验
            inputSplittedAmount: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isMoneyStr(value) && parseFloat(value) >= 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的数字!'));
                    }
                }
            },
            splittedAmountChange: function (rows) {
                let item = rows.row || {};
                let splittedAmount = item.splittedAmount || 0;
                let assetOrgWorth = item.assetOrgWorth || 0;
                if (Utils.isNoB(this.id) && parseFloat(splittedAmount) >= parseFloat(assetOrgWorth) && item.splitFlag) {
                    MsgBox.warning("调拨原值必须小于资产原值！");
                }
                item.splittedAmount = parseFloat(splittedAmount).toFixed(2);
                //
                this.transItemList = Utils.merge([], this.transVoucherInfo.itemList);
            },
            setPageList: function () {
                let totalRows = this.transVoucherInfo.itemList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                if (totalRows.length != 0 && start > (totalRows.length - 1)) {
                    this.pageNumber = this.pageNumber - 1;
                    start = (this.pageNumber - 1) * this.pageSize;
                    end = this.pageNumber * this.pageSize;
                }
                this.startIndex = start;
                this.endIndex = end;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageList();
            },
            // 保存调拨单
            saveTransVoucher: function (submitFlag) {
                if (!Utils.repeatChecker.isValidFor("saveTransVoucher", 1000)) {
                    return;
                }
                let self = this;
                let transVoucherInfo = Utils.merge({}, self.transVoucherInfo);
                transVoucherInfo.fiscalAcctFlag = true;    // 资产调拨
                //
                if (Utils.isNoB(transVoucherInfo.memo)) {
                    MsgBox.warning("请输入标题！");
                    return;
                } else if (transVoucherInfo.memo.length > 60) {
                    MsgBox.warning("标题不能超过60个字！");
                    return;
                }
                //
                self.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        if (transVoucherInfo.applyDesc.length > 250) {
                            MsgBox.warning("申请原因不能超过250个字！");
                            return;
                        }
                        let itemList = transVoucherInfo.itemList || [];
                        if (!Utils.isNoB(itemList) && itemList.length > 2000) {
                            Toast.show("资产总共不能超过3000条");
                            return;
                        }
                        //
                        let includeInUseDevc = false;  // 是否包含再用单品式资产
                        let errMsg = '';
                        if (itemList.length > 0) {
                            for (let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                if (Utils.isTrue(item.inUse)) {
                                    includeInUseDevc = true;
                                    break;
                                }
                                if (!Utils.isNoB(item.memo) && item.memo.length > 60) {
                                    errMsg = '资产信息[' + item.innerCode + ']的备注不能超过60个字！';
                                    break;
                                }
                                if (item.srcComId == item.dstComId) {
                                    errMsg = '资产[' + item.innerCode + ']的调入/出机构不可相同！';
                                    break;
                                }
                            }
                        }
                        if (!Utils.isNoB(errMsg)) {
                            MsgBox.warning(errMsg);
                            return;
                        }
                        //
                        self.doReqSaveTransVoucher(transVoucherInfo, includeInUseDevc, submitFlag);
                    }
                });
            },
            toInnerApplyTransVoucher: function (transVoucherInfo, submitFlag) {
                let self = this;
                // 获取最近一次审核人信息
                let params = {
                    bizUnitId: transVoucherInfo.srcBizUnitId,
                    voucherType: getEnumInfoWith('devcVoucherType', 'name', 'Allocation').value
                };
                let theLoad = MsgBox.loading();
                shopDeviceApi.getLastAuditInfo(params, function (resultX) {
                    theLoad.hide();
                    if (resultX.type == 'info') {
                        let auditInfo = resultX.data;
                        let initPostId = transVoucherInfo.auditorPostId;
                        let auditorStaffId = transVoucherInfo.auditorStaffId;
                        let auditorName = transVoucherInfo.auditorName;
                        if (!Utils.isNoB(auditInfo) && auditInfo.postId > 0) {
                            initPostId = auditInfo.postId;
                            auditorStaffId = auditInfo.staffId;
                            auditorName = auditInfo.staffName;
                        }
                        // 走内部审批
                        showComActionPostSelectDlg({
                            title: '调拨申请 - 指定审核岗',
                            rescUrl: SwbShopDeviceTransVoucherAuditList.path,
                            action: 'audit',
                            initPostId: initPostId,
                            useParents: true,
                            expandedParents: true,
                            showAuditor: !Utils.isNoB(auditorStaffId),
                            auditorStaffId: auditorStaffId,
                            auditorName: auditorName,
                            useDesc: false
                        }, function (resultData) {
                            resultData = resultData || {};
                            if (resultData.postId == null) {
                                Toast.show('请选择审核岗位', 3000, 'warning');
                                return false;
                            }
                            //
                            transVoucherInfo.auditorPostId = resultData.postId;
                            transVoucherInfo.auditorPostName = resultData.postName;
                            transVoucherInfo.auditComId = resultData.comId;
                            transVoucherInfo.auditComName = resultData.comName;
                            transVoucherInfo.auditComLevel = resultData.comLevel;
                            transVoucherInfo.auditorStaffId = resultData.auditorStaffId;
                            transVoucherInfo.auditorName = resultData.auditorName;
                            transVoucherInfo.applyDesc = resultData.applyDesc;
                            //
                            transVoucherInfo.applyState = 1;    // 自动申请
                            self.saveShopDeviceTransVoucher(transVoucherInfo, submitFlag);
                        }, this);
                    } else {
                        MsgBox.warning(resultX.message);
                    }
                });
            },
            doReqSaveTransVoucher: function (transVoucherInfo, includeInUseDevc, submitFlag) {
                let self = this;
                if (submitFlag) {
                    let itemList = transVoucherInfo.itemList || [];
                    // 检查是否需要生成虚拟调拨单（调入商户_调入机构是否有多个）
                    let virtualKey = null;
                    for (let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        let key = item.srcComId + "_" + item.dstMerchantId + "_" + item.dstComId;
                        if (virtualKey == null) {
                            virtualKey = item.srcComId + "_" + item.dstMerchantId + "_" + item.dstComId;
                        } else if (virtualKey != key) {
                            submitFlag = false;     // 调拨需拆单，不能弹出外部审批页面
                            break;
                        }
                    }
                }
                if (self.assetType != 2) {
                    transVoucherInfo.assetType = null;
                    //
                    if (Utils.isTrue(includeInUseDevc)) {
                        self.$confirm('调拨资产中如果包含在用将自动归还！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            self.submitTranVoucherFunc(transVoucherInfo, submitFlag);
                        });
                    } else {
                        self.submitTranVoucherFunc(transVoucherInfo, submitFlag);
                    }
                } else {
                    self.submitTranVoucherFunc(transVoucherInfo, submitFlag);
                }
            },
            submitTranVoucherFunc: function (transVoucherInfo, submitFlag) {
                let self = this;
                if (Utils.isNoB(self.id)) {
                    transVoucherInfo.reserveFlag = true;
                }
                if (submitFlag) {
                    if (self.dingDingAuditFlag) {
                        let submitTransVoucher = {
                            transVoucher: transVoucherInfo,
                        };
                        openAuditTypeDlg(null,function (auditType, theDlg) {
                            theDlg.close();
                            let dingDingFlag = Utils.isTrue(auditType);
                            if (dingDingFlag) {
                                let params = {
                                    bizVoucherId: transVoucherInfo.id,
                                    bizVoucherNo: transVoucherInfo.innerNo,
                                    bizTypeCode: 'retailer.assets.allot',
                                };
                                openDingdingAuditViewDlg(params, function (resultData) {
                                    let departId = resultData.departId;
                                    // 返回值：departId（部门ID）
                                    submitTransVoucher.departId = departId || null;
                                    submitTransVoucher.dingdingFlag = dingDingFlag;
                                    //
                                    self.doSubmitDeviceTransVoucher(submitTransVoucher);
                                });
                            } else {
                                // 申请内部审批
                                self.toInnerApplyTransVoucher(transVoucherInfo);
                            }
                        });
                    } else {
                        if (Utils.isTrue(self.isAuditBpConfAvailable)) {
                            let submitTransVoucher = {
                                transVoucher: transVoucherInfo,
                            };
                            if (self.needAssignAuditors) {
                                let params = {
                                    bizTypeCode: 'retailer.assets.allot',
                                    bizVoucherNo: transVoucherInfo.innerNo || transVoucherInfo.no,
                                    auditSeqNo: transVoucherInfo.auditSeqNo
                                };
                                openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                                    theDlg.close();
                                    auditorList = auditorList || [];
                                    if (auditorList.length <= 0) {
                                        MsgBox.warning("无审批人员信息");
                                        return;
                                    }
                                    submitTransVoucher.auditorList = Utils.merge([], auditorList);
                                    //
                                    self.doSubmitDeviceTransVoucher(submitTransVoucher);
                                });
                            } else {
                                submitTransVoucher.auditorList = [];
                                self.doSubmitDeviceTransVoucher(submitTransVoucher);
                            }
                        } else {
                            // 申请内部审批
                            self.toInnerApplyTransVoucher(transVoucherInfo, submitFlag);
                        }
                    }
                } else {
                    this.saveShopDeviceTransVoucher(transVoucherInfo, submitFlag);
                }
            },
            saveShopDeviceTransVoucher: function (transVoucherInfo, submitFlag) {
                let self = this;
                let theLoad = MsgBox.loading();
                assetVchrApi.saveShopDeviceTransVoucher(transVoucherInfo, function (result) {
                    theLoad.close();
                    if (result.type == "info") {
                        if (Utils.isNoB(transVoucherInfo.id) || submitFlag) {
                            let callback = function () {
                                self.$router.push({
                                    path: self.parentPath
                                });
                            };
                            MsgBox.success("保存成功", {callback: callback});
                        } else {
                            // self.srcTransVoucherInfo = Utils.merge({}, transVoucherInfo);
                            self.getShopDeviceTransVoucher(transVoucherInfo.id);
                            self.reloadItemInfo = !self.reloadItemInfo; // 重新渲染子项信息
                            //
                            MsgBox.success("保存成功");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 保存并申请接口
            doSubmitDeviceTransVoucher: function (submitTransVoucher) {
                let self = this;
                let theLoadX = MsgBox.loading();
                assetVchrApi.doSubmitDeviceTransVoucher(submitTransVoucher, function (resultX) {
                    if (resultX.type == 'info') {
                        let callback = function () {
                            self.$router.push({
                                path: self.parentPath
                            });
                            //
                            if (!self.needAssignAuditors && !self.dingDingAuditFlag) {
                                let auditBpStateInfo = resultX.data || {};
                                if (Utils.isTrue(auditBpStateInfo.outerAuditFlag) && !Utils.isTrue(auditBpStateInfo.bpStarted) && auditBpStateInfo.auditState == 0) {
                                    let params = {
                                        no: auditBpStateInfo.voucherNo
                                    };
                                    self.openOuterBpStartWin(params);
                                }
                            }
                        };
                        MsgBox.success('操作成功！', {callback: callback});
                    } else {
                        // 申请失败时，保证不会出现重复单据，再次提交视为修改
                        let auditBpStateInfo = resultX.data || {};
                        if (!Utils.isNoB(auditBpStateInfo.transVoucher) && !Utils.isNoB(auditBpStateInfo.transVoucher.id)) {
                            let transVoucherInfo = Utils.merge({}, self.transVoucherInfo);
                            transVoucherInfo.id = auditBpStateInfo.transVoucher.id;
                            //
                            self.transVoucherInfo = Utils.merge({}, transVoucherInfo);
                        }
                        //
                        MsgBox.failure(resultX.message);
                    }
                    theLoadX.hide();
                });
            },
            openOuterBpStartWin: function (row) {
                let self = this;
                let bizVoucherNo = row.no;
                if (!Utils.isNoB(row.innerNo)) {
                    bizVoucherNo = row.innerNo;
                }
                // let pageUrl = 'https://qa-oa-bpm.wumart.com/portal/r/w?cmd=com.awspaas.user.apps.assets.swb.redirectCmd&dircmd=CLIENT_BPM_FORM_MAIN_PAGE_OPEN&user_id=00000194&processInstId=706a1357-1f27-4692-9d08-0a42c8e94de2&sig=d6dbd24ddff9c6f98516e2992fd5de35';
                let params = {};
                params.bizTypeCode = 'retailer.assets.allot';
                params.bizVoucherNo = bizVoucherNo;
                params.auditSeqNo = row.auditSeqNo;
                oaAuditApi.getBpStartPageUrl(params, function (result) {
                    if (result.type === 'info') {
                        let pageUrl = result.data;
                        Utils.openWindow(pageUrl);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //返回
            prevStock: function () {
                let self = this;
                let srcTransVoucherInfo = Utils.merge({}, self.srcTransVoucherInfo);
                let transVoucherInfo = self.transVoucherInfo;
                //
                let srcItemLlist = Utils.merge([], self.srcItemList) || [];
                let transItemList = self.transItemList || [];
                //
                let ignore_props2 = ["transQuantity", "dstWareHouseList"];
                if (!Utils.isNoB(transVoucherInfo.id) && (!Utils.obj_val_equal(srcTransVoucherInfo, transVoucherInfo, false, []) || !Utils.obj_val_equal(srcItemLlist, transItemList, false, ignore_props2))) {
                    this.$confirm('存在未保存内容，是否确定关闭当前页面?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.$router.back(-1);
                    }).catch(function () {
                    });
                } else {
                    self.$router.back(-1);
                }
            },
            getCustTagMetaFields: function () {
                let self = this
                let param = [{tagMetaTableName: 'shop_device', tagMetaRole: 1}]
                custTagMeataApi.getCustTagMetaFields(param, function (result) {
                    if (result.type == 'info') {
                        let tags = result.data
                        for(let i=0; i< tags.length; i++) {
                            let tag = tags[i]
                            if(tag.fieldName == 'devcCustTag1') {
                                self.devcCustTag1 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag2') {
                                self.devcCustTag2 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag3') {
                                self.devcCustTag3 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(result.message)
                    }
                });
            },
            getDevcCustTagVal(pos, val) {
                if(val && val != -1) {
                    if(pos === 1) {
                        if(this.devcCustTag1.enabled == true) {
                            let items1 = this.devcCustTag1.itemList
                            for(var i = 0; i < items1.length; i++) {
                                let item1 = items1[i]
                                if(val == item1['id']) {
                                    return item1['name']
                                }
                            }
                        }
                    }else if(pos === 2){
                        if(this.devcCustTag2.enabled == true) {
                            let items2 = this.devcCustTag2.itemList
                            for(var i = 0; i < items2.length; i++) {
                                let item2 = items2[i]
                                if(val == item2['id']) {
                                    return item2['name']
                                }
                            }
                        }
                    }else if(pos === 3){
                        if(this.devcCustTag3.enabled == true) {
                            let items3 = this.devcCustTag3.itemList
                            for(var i = 0; i < items3.length; i++) {
                                let item3 = items3[i]
                                if(val == item3['id']) {
                                    return item3['name']
                                }
                            }
                        }
                    }
                }
                return null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherReserveSave.vue